import type { CurrencyDisplay } from './types';

export function formatPrice(priceILS: number, currency: CurrencyDisplay): string {
  const converted = priceILS * currency.exchange_rate;
  return `${converted.toFixed(2)} ${currency.symbol}`;
}
